module.exports = __webpack_public_path__ + "static/media/skills.ba14db6e.svg";